import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "firesafety-Fire-Hose",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Fire Hose",
    description: "Fire-Hose",
    image: require("./Fire-Hose.svg"),
    svgIcon: require("./Fire-Hose.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g>
          <defs>
            <style>{`.firehosecls1{fill:#d71214;}.firehosecls2{fill:#fff;}`}</style>
          </defs>
          <g
            transform={`translate(-47, 55) scale(1, -1)`}
            id={`${element.type}-${element.id}`}
            data-name="corner shower"
          >
            <path
              class="firehosecls1"
              d="M98.59,95.72H0V0H98.59Zm-70.72-20c.59.07,4.65,0,4.91,0V51c0-.69,0-1.38,0-2.06.56-.06,4.55,0,4.8,0V71.65c0,.68,0,1.36,0,2s0,1.37,0,2c.55.07,4.65,0,4.87,0,0,0,0,0,0,0a0,0,0,0,0,0,0V49.21s0-.07,0-.1v0a.13.13,0,0,1,0-.06s0,0,0,0l0,0h4.78V75.73a.54.54,0,0,0,.12,0H52l.15,0,0,0s0,0,.05-.06V49h4.82V75.74c.5.06,4.62,0,4.87,0V51.92c0-1,0-2,0-3h4.5V80.63c0,.07,0,.14,0,.2h5.86c0-.14,0-.26.06-.39.08-.65.16-1.31.23-2,.12-1,.24-2,.34-3s.2-2.25.28-3.37c.13-1.88.26-3.76.37-5.64.09-1.51.15-3,.21-4.52.09-2.3.17-4.59.23-6.89,0-1.94.06-3.87.09-5.81,0-.09,0-.18,0-.28h2.48c0,.13,0,.24.07.36a9.43,9.43,0,0,0,.65,2.32,10.12,10.12,0,0,0,2.4,3.45A9.85,9.85,0,0,0,82.69,57a10.55,10.55,0,0,0,11.24-1.78,10.22,10.22,0,0,0,2.13-2.72,9.56,9.56,0,0,0,1-3.2A8.85,8.85,0,0,0,97,45.93a9.93,9.93,0,0,0-2.29-4.55,10.15,10.15,0,0,0-3.33-2.48,10.54,10.54,0,0,0-10.95,1.24,9.88,9.88,0,0,0-3.55,5.6c-.07.35-.13.7-.2,1a12.53,12.53,0,0,1-2.51,0v-.4c-.08-3.43-.13-6.87-.23-10.3-.07-2.27-.19-4.53-.3-6.79-.07-1.47-.16-2.93-.27-4.4-.14-1.77-.32-3.53-.49-5.3-.12-1.25-.26-2.5-.39-3.74,0-.29-.08-.57-.12-.84-.37-.07-5.65-.05-5.91,0V46.77a45.07,45.07,0,0,1-4.51,0V19H57.09V46.59c0,.07,0,.14,0,.2h-4.8V19.06c-.37-.08-4.66-.06-4.92,0v27.7c-.43.07-4.58,0-4.82,0V19H37.6V46.79H32.78V21.36c0-.78,0-1.55,0-2.31-.45-.07-4.65-.05-4.91,0v27.7c-.33.07-4.55.06-4.83,0V19H18.16V46.26c0,.11,0,.21,0,.32a.78.78,0,0,1,0,.21H13.8V15.1c0-.12,0-.24,0-.35a1.2,1.2,0,0,0,0-.2H7.84A259.77,259.77,0,0,0,6.11,42.73H5.74c-.81,0-1.61,0-2.42,0-.21,0-.37,0-.47.24s-.3.49-.43.74a9.46,9.46,0,0,0-.77,2.49,9.72,9.72,0,0,0,.57,5.36c.17.43.43.82.63,1.24a.45.45,0,0,0,.47.24H6.1c0,.12,0,.19,0,.26.08,3.07.15,6.13.25,9.19.07,1.94.16,3.89.29,5.83.15,2.32.34,4.65.54,7,.15,1.69.35,3.38.52,5.07,0,.3.08.6.13.9h6V49h4.36V75.75H23V49c.44-.06,4.58,0,4.83,0Z"
            />
            <path
              class="firehosecls2"
              d="M27.87,75.74V49c-.25-.07-4.39-.09-4.83,0V75.75H18.17V49H13.81V81.25h-6c0-.3-.09-.6-.13-.9-.17-1.69-.37-3.38-.52-5.07-.2-2.32-.39-4.65-.54-7-.13-1.94-.22-3.89-.29-5.83-.1-3.06-.17-6.12-.25-9.19,0-.07,0-.14,0-.26H3.32a.45.45,0,0,1-.47-.24c-.2-.42-.46-.81-.63-1.24a9.72,9.72,0,0,1-.57-5.36,9.46,9.46,0,0,1,.77-2.49c.13-.25.3-.49.43-.74s.26-.24.47-.24c.81,0,1.61,0,2.42,0h.37A259.77,259.77,0,0,1,7.84,14.55h5.93a1.2,1.2,0,0,1,0,.2c0,.11,0,.23,0,.35V46.79h4.32a.78.78,0,0,0,0-.21c0-.11,0-.21,0-.32V19H23V46.76c.28.07,4.5.08,4.83,0V19.07c.26-.07,4.46-.09,4.91,0,0,.76,0,1.53,0,2.31V46.79H37.6V19h4.91V46.75c.24.08,4.39.1,4.82,0V19.08c.26-.08,4.55-.1,4.92,0V46.79h4.8c0-.06,0-.13,0-.2V19H62V46.75a45.07,45.07,0,0,0,4.51,0V15c.26-.07,5.54-.09,5.91,0,0,.27.09.55.12.84.13,1.24.27,2.49.39,3.74.17,1.77.35,3.53.49,5.3.11,1.47.2,2.93.27,4.4.11,2.26.23,4.52.3,6.79.1,3.43.15,6.87.23,10.3v.4a12.53,12.53,0,0,0,2.51,0c.07-.35.13-.7.2-1a9.88,9.88,0,0,1,3.55-5.6A10.54,10.54,0,0,1,91.38,38.9a10.15,10.15,0,0,1,3.33,2.48A9.93,9.93,0,0,1,97,45.93a8.85,8.85,0,0,1,.11,3.36,9.56,9.56,0,0,1-1,3.2,10.22,10.22,0,0,1-2.13,2.72A10.55,10.55,0,0,1,82.69,57a9.85,9.85,0,0,1-2.89-1.9,10.12,10.12,0,0,1-2.4-3.45,9.43,9.43,0,0,1-.65-2.32c0-.12,0-.23-.07-.36H74.2c0,.1,0,.19,0,.28,0,1.94,0,3.87-.09,5.81-.06,2.3-.14,4.59-.23,6.89-.06,1.51-.12,3-.21,4.52-.11,1.88-.24,3.76-.37,5.64-.08,1.12-.17,2.24-.28,3.37s-.22,2-.34,3c-.07.65-.15,1.31-.23,2,0,.13,0,.25-.06.39H66.51c0-.06,0-.13,0-.2V49H62c0,1,0,2,0,3V75.71c-.25.07-4.37.09-4.87,0V49H52.27v26.7s0,.06-.05.06l0,0-.15,0H47.47a.54.54,0,0,1-.12,0V49H42.57l0,0s0,0,0,0a.13.13,0,0,0,0,.06v0s0,.06,0,.1V75.66a0,0,0,0,1,0,0s0,0,0,0c-.22.06-4.32.09-4.87,0,0-.68,0-1.36,0-2s0-1.36,0-2V49c-.25-.08-4.24-.1-4.8,0,0,.68,0,1.37,0,2.06V75.71C32.52,75.78,28.46,75.81,27.87,75.74Zm57.5-35.19a7.46,7.46,0,0,0-6,5.88c.37.07,5.81,0,6-.06Zm-6,8.85a4,4,0,0,0,.28,1,7.39,7.39,0,0,0,2.27,3.21,7.86,7.86,0,0,0,3.29,1.61,1.94,1.94,0,0,0,.24,0c.07-.7,0-5.62-.06-5.85Zm9.16,5.84a7.52,7.52,0,0,0,4.41-2.55,6.77,6.77,0,0,0,1.6-3.34l-.16,0-5.71,0-.12,0,0,0h0Zm6-8.87a.81.81,0,0,0,0-.09.53.53,0,0,0,0-.12,7.22,7.22,0,0,0-.8-2,7.92,7.92,0,0,0-2.4-2.52,8.12,8.12,0,0,0-2.63-1.1h-.2c-.06.52,0,5.62.06,5.83Z"
            />
            <path
              class="firehosecls1"
              d="M85.37,40.55v5.82c-.22.08-5.66.13-6,.06A7.46,7.46,0,0,1,85.37,40.55Z"
            />
            <path
              class="firehosecls1"
              d="M79.34,49.4h6c.08.23.13,5.15.06,5.85a1.94,1.94,0,0,1-.24,0,7.86,7.86,0,0,1-3.29-1.61,7.39,7.39,0,0,1-2.27-3.21A4,4,0,0,1,79.34,49.4Z"
            />
            <path
              class="firehosecls1"
              d="M88.5,55.24V49.39h0l0,0,.12,0,5.71,0,.16,0a6.77,6.77,0,0,1-1.6,3.34A7.52,7.52,0,0,1,88.5,55.24Z"
            />
            <path
              class="firehosecls1"
              d="M94.47,46.37h-6c-.06-.21-.12-5.31-.06-5.83h.2a8.12,8.12,0,0,1,2.63,1.1,7.92,7.92,0,0,1,2.4,2.52,7.22,7.22,0,0,1,.8,2,.53.53,0,0,1,0,.12A.81.81,0,0,1,94.47,46.37Z"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
